import {
  Alert,
  AlertTitle,
  Button,
  Container,
  Link,
  Stack,
  Typography,
} from "@mui/material"
import { Link as RouterLink } from "react-router-dom"
import { useTitle } from "@core/hooks"
import { BOT_MONITOR_STATUSES } from "../constants/botMonitor"
import { BotMonitorFilters } from "../components/botMonitor/botMonitorFilters"
import { BotMonitorTable } from "../components/botMonitor/botMonitorTable"
import { useBotMonitorListState } from "../hooks/useBotMonitorListState"
import { useBotMonitorBotsQuery } from "../store/telegramApi"
import { classifyBotMonitorError } from "../utils/botMonitorError"

export const BotMonitorPage = () => {
  useTitle("PR Telegram — Мониторинг ботов")
  const state = useBotMonitorListState()
  const { currentData, isFetching, error, refetch } = useBotMonitorBotsQuery(
    state.queryArgs!,
    { skip: !state.queryArgs, refetchOnMountOrArgChange: true },
  )
  const failure =
    error && !isFetching ? classifyBotMonitorError(error) : undefined
  const visible =
    !isFetching && !error && state.result.ok ? currentData : undefined
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return (
    <Container maxWidth={false}>
      <Stack spacing={2}>
        <Typography variant="h4" component="h1">
          Мониторинг ботов
        </Typography>
        <Typography variant="body2">
          Часовой пояс браузера: {timezone}. Точные ISO UTC даты доступны в
          подсказках.
        </Typography>
        {!state.result.ok ? (
          <Alert severity="error">
            <AlertTitle>Некорректные параметры ссылки</AlertTitle>
            {Object.entries(state.result.errors).map(([field, reason]) => (
              <div key={field}>
                {field}: {reason}
              </div>
            ))}
            <Button onClick={state.reset}>Сбросить параметры</Button>
          </Alert>
        ) : (
          <>
            <BotMonitorFilters
              applied={{
                search: state.result.query.search ?? "",
                status: state.result.query.status ?? [...BOT_MONITOR_STATUSES],
              }}
              resetKey={state.draftResetKey}
              onApply={state.applyFilters}
            />
            {failure && (
              <Alert severity="error">
                <AlertTitle>{failure.title}</AlertTitle>
                <Typography
                  sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
                >
                  {failure.message}
                </Typography>
                {failure.kind === "unauthorized" && (
                  <Link component={RouterLink} to="/login">
                    Войти
                  </Link>
                )}
                <Button onClick={() => refetch()} disabled={isFetching}>
                  Повторить загрузку
                </Button>
              </Alert>
            )}
            <BotMonitorTable
              rows={visible?.items ?? []}
              total={visible?.total}
              loading={isFetching}
              failed={!!error}
              limit={state.result.query.limit}
              offset={state.result.query.offset}
              sortModel={state.sortModel}
              onSortChange={state.setSort}
              onOffsetChange={state.setOffset}
              onLimitChange={state.setLimit}
            />
          </>
        )}
      </Stack>
    </Container>
  )
}
